import { Code2, Server, BrainCircuit, Cloud } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { Reveal, Overline } from "./Reveal";

const ICONS = [Code2, Server, BrainCircuit, Cloud];

export default function TechStack() {
  const { t } = useLang();
  return (
    <section className="relative py-28 md:py-36">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-8 items-end mb-14">
          <div className="lg:col-span-7">
            <Reveal><Overline>{t.tech.overline}</Overline></Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-head font-bold tracking-tighter text-ink text-[clamp(2.25rem,5vw,4.5rem)] leading-[0.95] mt-5">
                {t.tech.title}
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1} className="lg:col-span-5">
            <p className="text-base md:text-lg text-ink-2 leading-relaxed">{t.tech.subtitle}</p>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {t.tech.groups.map((g, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal
                key={g.name}
                delay={i * 0.08}
                className="group rounded-2xl border border-line hover:border-brand bg-bg-2 p-7 transition-colors duration-500"
                data-testid={`tech-group-${i}`}
              >
                <div className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-brand/10 text-brand group-hover:bg-brand group-hover:text-white transition-colors duration-500">
                  <Icon className="h-5 w-5" />
                </div>
                <h3 className="font-head font-bold text-ink text-xl tracking-tight mt-6">{g.name}</h3>
                <ul className="mt-4 space-y-2">
                  {g.items.map((item) => (
                    <li key={item} className="font-mono text-sm text-ink-2 flex items-center gap-2">
                      <span className="h-1 w-1 rounded-full bg-brand" />
                      {item}
                    </li>
                  ))}
                </ul>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
